import React from "react";
import { StyleSheet, Pressable } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTheme } from "@/hooks/useTheme";
import type { ConfirmationToggleProps } from "./types";

export function ConfirmationToggle({ label, checked, onToggle }: ConfirmationToggleProps) {
  const { colors } = useTheme();

  return (
    <Pressable style={styles.container} onPress={onToggle}>
      <MaterialCommunityIcons
        name={checked ? "checkbox-marked" : "checkbox-blank-outline"}
        size={18}
        color={checked ? colors.primary : colors.textSecondary}
      />
      <ThemedText style={[styles.label, { color: colors.textSecondary }]}>{label}</ThemedText>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
  },
  label: {
    fontSize: 12,
  },
});
